import { render, staticRenderFns } from "./DefaultBackend.vue?vue&type=template&id=795f43c9&"
import script from "./DefaultBackend.vue?vue&type=script&lang=js&"
export * from "./DefaultBackend.vue?vue&type=script&lang=js&"
import style0 from "./DefaultBackend.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports